import { render, staticRenderFns } from "./tuishuizhanshi.vue?vue&type=template&id=2ab87178&scoped=true"
import script from "./tuishuizhanshi.vue?vue&type=script&lang=js"
export * from "./tuishuizhanshi.vue?vue&type=script&lang=js"
import style0 from "./tuishuizhanshi.vue?vue&type=style&index=0&id=2ab87178&prod&scoped=true&lang=css"
import style1 from "./tuishuizhanshi.vue?vue&type=style&index=1&id=2ab87178&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab87178",
  null
  
)

export default component.exports